$(document).ready(function() {
  var currentYearIndex = 0;
  var scrolling = false; 
  function showContent(yearIndex) {
    var $allContent = $('.year-content');
    var $selectedContent = $(`.year-content[data-year="${$allContent.eq(yearIndex).data('year')}"]`);
    $allContent.removeClass('active').hide(); 
    $selectedContent.addClass('active').show(); 
    var progress = (yearIndex / ($allContent.length - 1)) * 100;
    $('.progress-bar-wrapper .progress-bar').css('width', progress + '%');
    $('.dot').removeClass('selected');
    $(`.dot[data-year="${$selectedContent.data('year')}"]`).addClass('selected');
  }

  $('.dot').on('click', function() {
    var year = $(this).data('year');
    var yearIndex = $('.year-content').filter(`[data-year="${year}"]`).index();
    currentYearIndex = yearIndex;
    showContent(currentYearIndex);
  });
let range = $('.timeline_range').length-1;
  // Mouse scroll functionality with a delay for #content div only
  // $('#content').on('wheel', function(e) {
    
  //   e.preventDefault();
  //   if (scrolling) return;
  //   scrolling = true;
  //   setTimeout(function() {
  //     if (e.originalEvent.deltaY > 0) {
  //       // Scroll down
  //       if (currentYearIndex < $('.year-content').length - 1) {
  //         currentYearIndex++;
  //          console.log("Scrolling down (bottom ki taraf)");
  //       }else{
          
  //       }
  //     } else {
  //       // Scroll up
  //       if (currentYearIndex > 0) {
  //         currentYearIndex--;
  //          console.log("Scrolling top (bottom ki taraf)");
  //       }
  //     }
  //     showContent(currentYearIndex);
  //     scrolling = false;
  //   }, 500);
  // });

  showContent(currentYearIndex);
});
